// extracted by mini-css-extract-plugin
module.exports = {"VirtualDaysRow":"VirtualDaysRow__1QwhL","Day":"Day__2K9VZ"};